import { format } from 'date-fns';
import {
  GET_ITEMEXPANDED_FAILURE,
  GET_ITEMEXPANDED_REQUEST,
  GET_ITEMEXPANDED_SUCCESS,
  GET_ITEMEXPANDED_TIMEOUT
} from '../constants/ActionTypes';
import { parseISOLocal } from '../utils/date';
import { dispatchError, fetchPost } from '../utils/fetch';
import getItemModsForItemExpanded from '../utils/getModsForGetItemExpanded';

function getItemExpandedRequest(day, pkg) {
  return {
    type: GET_ITEMEXPANDED_REQUEST,
    day,
    pkg
  };
}

function getItemExpandedFailure(day, pkg, error, errors) {
  return {
    type: GET_ITEMEXPANDED_FAILURE,
    day,
    error,
    errors,
    pkg
  };
}

function getItemExpandedSuccess(day, pkg, items) {
  return {
    type: GET_ITEMEXPANDED_SUCCESS,
    day,
    items,
    pkg,
    date: new Date(),
    timeout: setTimeout(getItemExpandedTimeout, 5000)
  };
}

function getItemExpandedTimeout() {
  return {
    type: GET_ITEMEXPANDED_TIMEOUT
  };
}

export default function getItemExpanded(item, mods) {
  return (dispatch, getState) => {
    const {
      config,
      sale: {
        sale,
        sale: { day }
      },
      inventory,
      inventory: { cacheBust }
    } = getState();

    if (mods == null) {
      mods = getItemModsForItemExpanded(
        inventory,
        sale,
        item,
        sale.packageAddOns
      );
    }

    new Promise((resolve, reject) => {
      dispatch(getItemExpandedRequest(day, item));

      const date = parseISOLocal(day);
      const dateString = format(date, 'yyyyMMdd');

      fetchPost(
        config,
        'items/expanded',
        {
          startDate: dateString,
          startTime: '000000',
          endDate: dateString,
          endTime: '235959',
          cacheBust: cacheBust
        },
        {
          item: item.item,
          category: item.category,
          department: item.department,
          qty: item.qty,
          mods: mods.map(addOn => {
            return {
              item: addOn.item,
              category: addOn.category,
              department: addOn.department,
              qty: addOn.qty
            };
          })
        }
      )
        .then(items => {
          var itemsMap = {};
          for (var i of items) {
            itemsMap[i.item_id] = i;
          }
          dispatch(getItemExpandedSuccess(day, item, itemsMap));
          resolve();
        })
        .catch((...args) => {
          dispatchError(dispatch, getItemExpandedFailure.bind(this, day, item))(
            ...args
          );
          reject(...args);
        });
    });
  };
}
